module.exports = __webpack_public_path__ + "static/media/cred-7.f7cc44dd.jpg";